export default [
    {
        path: '/process/BscProProdef',
        component: () => import( '@/views/process/BscProProdef.vue'),
        meta: {
            title: '流程管理',
            isTabsPage: true,
            keepAlive:true
        }
    },
    {
        path: '/process/BscProProdefFlower',
        component: () => import( '@/views/process/BscProProdefFlower.vue'),

    },
    {
        path: '/process/viewpregress',
        component: () => import( '@/views/process/viewpregresshistory.vue'),
    },
    {
        path: '/process/BscProInstList',
        component: () => import( '@/views/process/BscProInstList.vue'),
        meta: {
            title: '流程实例管理',
            isTabsPage: true,
            keepAlive:true
        }
    },
    {
        path: '/demo/complatetask',
        component: () => import( '@/views/demo/complatetask.vue'),

    },
]
